import Util from '@/assets/libs/util.js'
import CampaignFidelityGcomController from './CampaignFidelityGcomController'
import CampaignFidelityCrmBonusController from './CampaignFidelityCrmBonusController'
import CampaignFidelityTEKController from './CampaignFidelityTEKController'
import CampaignFidelityOlgaController from './CampaignFidelityOlgaController'
import CampaignFidelityCrmFixeController from './CampaignFidelityCrmFixeController'
// import Util from '@/assets/libs/util.js'
// const askPhoneNumber = Util.askPhoneNumber()

// variaveis utilizadas em ambos
let phone = ''
let documentNumber = ''
let discount = 0
let processed = false
let hasError = false
let campaignEnabled = null // 1 - CRM&Bonus, 2 - Campanha de cashback Teknisa, 3 Gcom - 4 - Cashback Olga - 5 - CRM Fixe - none não ha nenhuma integração ativa
let campaignParams = null
let totalSaleValue = 0

const checkStatus = async function () {
    /* verifica se tem e qual campanha de cashback esta ativa  priorizando
        a campanha de cashback da teknisa */

    if (!campaignEnabled) {
        let cashbackCampaignStatus = await CampaignFidelityTEKController.getCampaign()
        if (cashbackCampaignStatus) {
            campaignEnabled = 2
        }
    }

    if (!campaignEnabled) {
        let result = await CampaignFidelityCrmBonusController.getCRMStatus()
        if (result) {
            campaignEnabled = 1
        }
    }

    if (!campaignEnabled) {
        let gcomApiStatus = await CampaignFidelityGcomController.getApiGcomStatus()
        if (gcomApiStatus) {
            campaignEnabled = 3
        }
    }

    if (!campaignEnabled) {
        let cashbackCampaignStatus = await CampaignFidelityOlgaController.checkStatus()
        if (cashbackCampaignStatus) {
            campaignEnabled = 4
            campaignParams = await CampaignFidelityOlgaController.getCashbackPrograms()
        }
    }

    if (!campaignEnabled) {
        let crmFixeStatus = await CampaignFidelityCrmFixeController.checkStatus()
        if (crmFixeStatus) {
            campaignEnabled = 5
        }
    }

    if (!campaignEnabled) {
        campaignEnabled = 'none'
        console.log('Nenhuma campanha de cashback ativa')
    }
    return campaignEnabled
} // ok

const getBalance = async function (value) {
    if (hasError || !haveSomeIdentifier()) {
        return false
    }
    if (campaignEnabled === 1) {
        return CampaignFidelityCrmBonusController.getCRMBalance(value, phone)
    }
    if (campaignEnabled === 2) {
        return CampaignFidelityTEKController.getCashbackCampaignBalance(phone)
    }
    if (campaignEnabled === 3) {
        return CampaignFidelityGcomController.getBalance(phone)
    }
} // não tem

const getResume = async function () {
    if (hasError || !haveSomeIdentifier()) {
        return false
    }
    if (campaignEnabled === 1) {
        let balanceCRM = await CampaignFidelityCrmBonusController.getCRMBalance(10000, phone)
        return {
            campaignEnabled: 1,
            totalBalance: balanceCRM.balance._text
        }
    }
    if (campaignEnabled === 2) {
        return CampaignFidelityTEKController.campaignGetBalanceResume()
    }
    if (campaignEnabled === 3) {
        let resume = await CampaignFidelityGcomController.getBalance(phone)
        if (resume && resume.expiredbalance && resume.expiredbalance._text) {
            return {
                campaignEnabled: 3,
                expiration: resume.expiredbalance._text,
                totalBalance: resume.balance._text
            }
        }
    }
    if (campaignEnabled === 4) {
        return CampaignFidelityOlgaController.getResume()
    }
    if (campaignEnabled === 5) {
        return CampaignFidelityCrmFixeController.getResume()
    }

    return false
}

const applyDiscount = async function (saleData) {
    let result = null
    if (hasError || !haveSomeIdentifier()) {
        return false
    }
    if (phone && campaignEnabled === 1) {
        result = await CampaignFidelityCrmBonusController.applyCRMDiscount(saleData, phone, totalSaleValue, discount)
        if (!result || hasError) {
            console.log('Falha na rotina applyCRMDiscount')
            throw new Error('Falha na rotina applyCRMDiscount')
        }
        let bonusId = result.bonusId && result.bonusId._text
        let orderIdCRM = result.orderIdCRM && result.orderIdCRM._text
        if (bonusId && orderIdCRM) {
            result = await CampaignFidelityCrmBonusController.addTotalSaleCRM(bonusId, orderIdCRM, phone, totalSaleValue)
            if (!result) {
                console.log('Falha na rotina addTotalSaleCRM')
                throw new Error('Falha na rotina addTotalSaleCRM')
            }
            // console.log('desconto aplicado com sucesso')
            return true
        }
    }
    if (phone && campaignEnabled === 2) {
        if (discount) {
            result = await CampaignFidelityTEKController.campaignRedeemBalance(saleData, phone, discount)
            if (!result || hasError) {
                console.log('Falha na rotina campaignRedeemBalance')
                throw new Error('Falha na rotina campaignRedeemBalance')
            }
        }
        result = await CampaignFidelityTEKController.campaignCreditBalance(saleData, phone)
        if (!result || hasError) {
            // caso tiver aplicado do desconto chamar a cancel balance pra desfazer
            console.log('Falha na rotina campaignCreditBalance')
            throw new Error('Falha na rotina campaignCreditBalance')
        }
        result = await CampaignFidelityTEKController.campaignGetSaleResume(saleData, phone)
        if (!result || hasError) {
            // caso tiver aplicado do desconto chamar a cancel balance pra desfazer
            console.log('Falha na rotina campaignGetSaleResume')
            // throw new Error('Falha na rotina campaignGetSaleResume')
            /* quando não pontua essa rota vode retorar vazia porem não deve causar o cancelamento da venda */
        }
    }
    if (phone && campaignEnabled === 3) {
        result = await CampaignFidelityGcomController.generateBalance(saleData, discount, phone, totalSaleValue)
    }

    if (phone && campaignEnabled === 4) {
        await CampaignFidelityOlgaController.confirmGift(phone, saleData, discount)
        result = await CampaignFidelityOlgaController.orderGift(phone)
        if (!result || hasError) {
            console.log('Falha na rotina orderGift')
            throw new Error('Falha na rotina orderGift')
        }
    }

    if (documentNumber && campaignEnabled === 5) {
        if (discount > 0) {
            result = await CampaignFidelityCrmFixeController.redeemPoints(saleData, discount)
            if ((!result || hasError)) {
                Util.logComunication('CampaignFidelityCrmFixeController.redeemPoints', {saleData, totalSaleValue}, result, true)
                throw new Error('Falha na rotina redeemPoints')
            }
        } else if (CampaignFidelityCrmFixeController.getHasFidelity()) {
            let saleResult = await CampaignFidelityCrmFixeController.makeSale(saleData)
            if (!saleResult || hasError) {
                Util.logComunication('CampaignFidelityCrmFixeController.makeSale', {saleData}, saleResult, true)
                throw new Error('Falha na rotina makeSale')
            }
        }
        CampaignFidelityCrmFixeController.setSaleData(saleData)
    }
}

const validateCoupon = async function (value, phone) {
    if (campaignEnabled === 4) {
        return CampaignFidelityOlgaController.getGiftsQrcode(value, phone)
    }
    return false
}

const setGiftApplied = function (gift) {
    if (campaignEnabled === 4) {
        CampaignFidelityOlgaController.setGiftApplied(gift)
    }
}

const getGiftApplied = function () {
    if (campaignEnabled === 4) {
        return CampaignFidelityOlgaController.getGiftApplied()
    }
    return []
}

const removeGiftApplied = function (key) {
    if (campaignEnabled === 4) {
        CampaignFidelityOlgaController.removeGiftApplied(key)
    }
}

const getClientInfo = async function (identifier) {
    if (campaignEnabled === 4) {
        return CampaignFidelityOlgaController.getClientInfo(identifier)
    }

    if (campaignEnabled === 5) {
        return CampaignFidelityCrmFixeController.getClientInfo(identifier)
    }
    return null
}

const getCouponsAvailable = function () {
    if (campaignEnabled === 4) {
        return CampaignFidelityOlgaController.getCouponsAvailable()
    }
    return []
}

const validateGift = async function (id, type, phone) {
    if (campaignEnabled === 4) {
        return CampaignFidelityOlgaController.validateGift(id, type, phone)
    }
    return false
}

const haveSomeIdentifier = function () {
    return !!phone || !!documentNumber
}

export default {
    getBalance,
    applyDiscount,
    getResume,
    setDocumentNumber: (docNumber) => {
        documentNumber = docNumber
    },
    getDocumentNumber: () => {
        return documentNumber
    },
    clearDocumentNumber: () => {
        documentNumber = ''
    },
    setPhone: (phoneNumber) => {
        phone = phoneNumber
    },
    getPhone: () => {
        return phone
    },
    clearPhone: () => {
        phone = ''
    },
    setDiscount: async (value) => {
        discount = value
        if (campaignEnabled === 3) {
            return CampaignFidelityGcomController.balanceReserve(value)
        }
        return {
            error: false,
            message: ''
        }
    },
    getDiscountApplied: () => {
        return {
            value: discount,
            campaignEnabled: campaignEnabled
        }
    },
    setTotalSaleValue: (value) => {
        totalSaleValue = value
    },
    getTotalSaleValue: () => {
        return totalSaleValue
    },
    setProcessedStatus: (value) => {
        processed = value
    },
    getStatus: async (hasToPrint = false) => {
        // caso seja para impressao verifica também se foi digitado um telefone
        if (hasToPrint && !haveSomeIdentifier()) {
            return {
                status: false,
                processed: false,
                campaignEnabled: 'none'
            }
        }
        return {
            status: !hasError && haveSomeIdentifier(),
            processed: processed,
            campaignEnabled: await checkStatus(),
            campaignParams: campaignParams
        }
    },
    clearData: () => {
        phone = ''
        documentNumber = ''
        totalSaleValue = 0
        discount = 0
        hasError = false
        processed = false
        CampaignFidelityGcomController.clearData()
        CampaignFidelityCrmBonusController.clearCRMData()
        CampaignFidelityTEKController.clearCampaignData()
        CampaignFidelityOlgaController.clearData()
        CampaignFidelityCrmFixeController.clearData()
    },
    getCashbackBonusValue: () => {
        if (campaignEnabled === 1) {
            return CampaignFidelityCrmBonusController.getCRMBonusBalance()
        }
        if (campaignEnabled === 2) {
            return CampaignFidelityTEKController.getCashbackBonusValue()
        }
        if (campaignEnabled === 3) {
            return CampaignFidelityGcomController.getBalanceValue(totalSaleValue)
        }
        /* if (campaignEnabled === 4) {
        } */
        return {
            available: 0,
            maxValue: 0
        }
    },
    getConsumerData: () => {
        if (campaignEnabled === 3) {
            return CampaignFidelityGcomController.getConsumerData()
        }
        if (campaignEnabled === 2) {
            return CampaignFidelityTEKController.getConsumerData()
        }
        if (campaignEnabled === 4) {
            return CampaignFidelityOlgaController.getClientData()
        }
        if (campaignEnabled === 5) {
            return CampaignFidelityCrmFixeController.getClientData()
        }
        return null
    },
    deleteReverve: async function () {
        if (campaignEnabled === 3) {
            return CampaignFidelityGcomController.deleteReverve()
        }

        if (campaignEnabled === 5) {
            await CampaignFidelityCrmFixeController.chargebackSale()
        }
    },
    getPinValidationStatus: async function (phone) {
        return CampaignFidelityCrmBonusController.getPinValidationStatus(phone)
    },
    validatePin: async function (params) {
        return CampaignFidelityCrmBonusController.validatePin(params)
    },
    resendPin: async function (params) {
        return CampaignFidelityCrmBonusController.resendPin(params)
    },
    validateCoupon,
    setGiftApplied,
    getGiftApplied,
    removeGiftApplied,
    getClientInfo,
    getCouponsAvailable,
    validateGift
}



// WEBPACK FOOTER //
// ./src/assets/controllers/CashbackCampaingController.js